<template>
    <el-date-picker v-model="date" type="daterange" align="right" value-format="yyyy-MM-dd" unlink-panels range-separator=" " :offset="[-10,10]" class="custom-date-picker"
    :start-placeholder="$t('language.emailTransfer.startDate')" :end-placeholder="$t('language.emailTransfer.endDate')" :append-to-body="false" :clearable="false">
        <template v-slot:range-separator>
            <i class="icon-util arrow-purple arrow-purple-position"></i>
        </template>
    </el-date-picker>
</template>

<script>
import "@/assets/css/time_selector.css";
export default {
    props: [],
    data: function () {
        return {
            date: null,
        };
    },
    created() {
    },
    watch: {
    },
    methods: {
    }
};
</script>

<style scoped>
.custom-date-picker >>> .el-popper{
    right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/selector/date_selector.vue